module.exports = __webpack_public_path__ + "static/media/MPD-Logo.abc36dfa.png";